import React, { useMemo, useEffect } from "react";
import C from "Constants";
import { createServiceTypeArray } from "utils/Utils";
import CustomModal from "components/CustomModal";
import ConfirmModal from "components/Modals/ConfirmModal";
import { useLang } from "hooks";
import { TranslationText } from "../TextTranslationContainer";
import useServiceType from "./useChangeServiceType";
import { useSelector } from "react-redux";

const ServiceTypeToggler = ({containerClassName="mx-4 mt-3"}) => {
  const {
    setServiceType,
    confirmModal,
    setConfirmModal,
    confirmModalTitle,
    handleConfirmModal,
    handleCancelModal,
  } = useServiceType();

  const { isArabic } = useLang();

  const { orderType } = useSelector((state) => state?.AppReducer);
  const { brandInfo } = useSelector((state) => state?.brandStorageReducer);

  const activeServices = useMemo(() => {
    return createServiceTypeArray(brandInfo?.setting);
  }, [brandInfo?.setting]);

  useEffect(() => {
    if (activeServices?.length === 1 && brandInfo?.setting?.enableStoreListingView && !orderType) {
      setServiceType(activeServices[0]);
    }
  }, [activeServices, brandInfo?.setting?.enableStoreListingView, orderType]);

  const getServiceType = (service) => {
    return service?.["EN"]?.name === C.SERVICE_TYPE.DELIVERY
      ? "Delivery"
      : "Pickup";
  };

  if (activeServices?.length <= 1 ) return null;


  return (
    <>
      <div
        className={
          `relative grid ${activeServices?.length === 1 ? "grid-cols-1" : "grid-cols-2"} items-center rounded-full p-2 gap-1 h-14 bg-#F9FAFB ${containerClassName}`
        }
        dir={"ltr"}
      >
        {activeServices?.map((service, index) => {
          const isActive = service?.["EN"]?.name === orderType?.["EN"]?.name;
          return (
            <button
              key={index}
              className={`text-center ${
                isActive
                  ? "bg-brand-base-primary text-white h-full rounded-full text-center"
                  : "bg-transparent text-#898989 hover:bg-brand-base-primary hover:text-white hover:h-full hover:rounded-full"
              }`}
              onClick={() => {
                setServiceType(service);
              }}
            >
              <TranslationText text={getServiceType(service)} />
            </button>
          );
        })}
      </div>
      <CustomModal
        open={confirmModal}
        setOpen={setConfirmModal}
        bodyclasses="flex"
        overlayClasses={`fixed h-screen w-screen top-0  bg-black bg-opacity-50 overflow-hidden transition ease-linear duration-700 z-150 ${
          isArabic === "AR" ? "border-sc-l" : "border-sc"
        }`}
      >
        <ConfirmModal
          onConfirm={handleConfirmModal}
          onCancel={handleCancelModal}
          title={confirmModalTitle}
        />
      </CustomModal>
    </>
  );
};

export default ServiceTypeToggler;
